import CLobby from "./CLobby";
import { useUser } from "../../../ducks/user";

import DailyNotMember from "./DailyNotMember";
import { useSignIn } from "@/src/ducks/signIn";

export default function CLobbyMain() {
  const { memberLoggedIn } = useUser();
  const { loading } = useSignIn();

  return (
    <div
      className={`relative flex flex-col w-full h-full bg-white rounded-md `}
    >
      {!memberLoggedIn && !loading && (
        <div className="absolute z-30 flex flex-col items-center justify-center w-full h-full rounded-b-md backdrop-brightness-90">
          <DailyNotMember />
        </div>
      )}
      <CLobby />
    </div>
  );
}
